<template>
  <div class="company-container">
    <el-select v-model="form.supplierId" placeholder="请选择保险公司" :filterable="true" :clearable="clearable" :disabled="disabled"
      :filter-method="filterCompany" @clear="companyClear" class="el-select-90" @change="supplierChange"
      v-if="!$attrs.multiple" v-bind="$attrs">
      <el-option v-for="item in companies" :key="item.Value" :label="getLabel(item)" :value="item.Value" :disabled="disableList.includes(item.value)"></el-option>
    </el-select>
    <ybl-multi-select v-model="form.supplierId" :items="companies" :props="jobnumProps" placeholder="请选择保险公司" :clearable="clearable"
      filterable v-else :filter-method="filterCompany" @change="supplierChange" :disableList="disableList"></ybl-multi-select>
  </div>
</template>

<script>
// import { companyArray } from '@/data/company'
import { mapGetters } from 'vuex'
export default {
  name: 'yblCompany',
  model: {
    prop: 'item',
    event: 'change'
  },
  props: {
    item: {
      type: String | Number | Array,
      default: () => ''
    },
    disableList: { // 禁用的保司
      type: Array,
      default: () => []
    },
    isFeiche: { // 是否非车 （true 非车 false 车险）（非车是指所有-包含车险）
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    clearable: {
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      companies: [],
      calcCompany: [],
      form: {
        supplierId: ''
      },
      jobnumProps: {
        label: 'Label',
        value: 'Value',
        disabled: 'Status',
        disabledValue: 9
      }
    }
  },
  created () {
    // console.log('this.item = ', this.item)
    if (this.originCompany && this.originCompany.length) {
      this.companies = this.originCompany
      this.calcCompany = [...this.originCompany]
      if (this.item) {
        // this.form.supplierId = `${this.item}`
        this.setSupplierId()
      }
    } else {
      this.getSmallSuppliers().then(() => {
        if (this.item) {
          // this.form.supplierId = `${this.item}`
          // this.$emit('change', this.item)
          this.setSupplierId()
        }
      })
    }
  },
  computed: {
    ...mapGetters([
      'JOBNO_GETSMALLSUPPLIERS',
      'commonData'
    ]),
    originCompany_vuex () {
      return this.JOBNO_GETSMALLSUPPLIERS && this.JOBNO_GETSMALLSUPPLIERS.datas
    },
    originCompany () {
      let action = `GETSMALLSUPPLIERS_${this.isFeiche ? 'FEICHE' : ''}`
      return this.commonData[action]
    }
  },
  methods: {
    getSmallSuppliers () {
      let params = {}
      if (this.isFeiche) {
        params = {
          params: {
            filterWithJob: 0,
            partnerLevel: -1
          }
        }
      }
      return this.$store.dispatch('jobNoGetSmallSuppliers', params).then(data => {
        console.log(data)
        let _data = data.datas || []
        let key = `GETSMALLSUPPLIERS_${this.isFeiche ? 'FEICHE' : ''}`
        if (_data && _data.length) {
          let params = { key: key, value: _data }
          this.$store.dispatch('setCommon', params)
        }
        this.companies = _data
        this.calcCompany = [..._data]
        return data
      })
    },
    getLabel (optionItem) {
      let label = optionItem.Label
      let letter = optionItem.Title.substring(0, 1).toUpperCase()
      label = `${letter}-${label}`
      return label
    },
    setSupplierId () {
      if (this.item && !Array.isArray(this.item)) {
        this.form.supplierId = `${this.item}`
      } else if (this.item.length) {
        this.form.supplierId = this.item
      }
    },
    filterCompany (val) {
      if (val) {
        val = val.toLowerCase()
        this.companies = this.calcCompany.filter(item => `${item.Label}${item.Title}`.toLowerCase().indexOf(val) !== -1)
        if (val.length === 1) {
          this.companies = this.calcCompany.filter(item => item.Title.substring(0, 1).toLowerCase() === val)
        }
      } else {
        this.companies = this.calcCompany
      }
    },
    companyClear () {
      this.companies = this.calcCompany
      // this.$emit('change', '')
    },
    supplierChange (val) {
      let supplierName = ''
      if (val && this.$attrs.multiple === undefined) {
        supplierName = this.calcCompany.find(c => +c.Value === +val).Label
      }

      this.$emit('change', val, supplierName)
      this.companyClear()
      // this.$emit('update:item', val)
    }
  },
  watch: {
    'item': function (newVal, oldVal) {
      // if (this.item) {
      //   this.form.supplierId = `${this.item}`
      // }
      // this.form.supplierId = `${this.item}`
      if (newVal && !Array.isArray(newVal)) {
        this.form.supplierId = `${this.item}`
      } else if (newVal.length) {
        this.form.supplierId = newVal
      } else if (!newVal) {
        this.form.supplierId = ''
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Company.vue